import {PropertyType} from '@mintdata-wsp/common/state/ui/visualDesigner/VisualDesignerState';

export class CloudTypesManager
{
    private _isString(typeDescriptor:string):boolean
    {
        if( !typeDescriptor )
        {
            return false;
        }

        const td = typeDescriptor.toLowerCase();

        return ['java.lang.string', 'string'].indexOf(td) !== -1;
    }

    private _isNumber(typeDescriptor:string):boolean
    {
        if( !typeDescriptor )
        {
            return false;
        }

        const td = typeDescriptor.toLowerCase();

        return [
            'java.lang.integer',
            'int',
            'java.lang.float',
            'float',
            'java.lang.double',
            'double',
        ].indexOf(td) !== -1;
    }

    private _isBoolean(typeDescriptor:string):boolean
    {
        return typeDescriptor && typeDescriptor.toLowerCase() === 'boolean';
    }

    private _isMap(typeDescriptor:string):boolean
    {
        if( !typeDescriptor )
        {
            return false;
        }

        const td = typeDescriptor.toLowerCase();

        return td.startsWith('java.util.map<') ||
            td.startsWith('map<');
    }

    private _isList(typeDescriptor:string):boolean
    {
        if( !typeDescriptor )
        {
            return false;
        }

        const td = typeDescriptor.toLowerCase();

        return [
            'java.lang.string[]',
            'java.lang.integer[]',
            'java.lang.float[]',
            'java.lang.double[]',
            'boolean[]',
        ].indexOf(td) !== -1;
    }

    public getType(typeDescriptor:string):PropertyType
    {
        if( this._isString(typeDescriptor) )
        {
            return PropertyType.String;
        }

        if( this._isBoolean(typeDescriptor) )
        {
            return PropertyType.Boolean;
        }

        if( this._isNumber(typeDescriptor) )
        {
            return PropertyType.Number;
        }

        if( this._isMap(typeDescriptor) )
        {
            return PropertyType.Map;
        }

        if( this._isList(typeDescriptor) )
        {
            return PropertyType.List;
        }
    }

    public getMapKeyValueTypes(typeDescriptor:string):[string, string]
    {
        const matches = typeDescriptor ? typeDescriptor.match(/java\.util\.map<(.+),\s*(.+)>/i) : [];

        return [matches[1], matches[2]];
    }

    public getListItemType(typeDescriptor:string):string
    {
        if( typeDescriptor )
        {
            return typeDescriptor.replace('[]', '');
        }
    }
}
